export default {"src":"/_next/static/media/img_main_section3_11.12b74184.svg","height":156,"width":320,"blurWidth":0,"blurHeight":0};